import React from "react";
import CircleColor from "../CircleColor/CircleColor";
import styles from "./ChoiceColor.module.scss";
import { Color } from "../../../../../store/types/store";
import { isNewSite } from "../../../../../utils";

interface ChoiceColorProps {
    color: Color;
    setColor: (color: Color) => void;
}

const ChoiceColor = ({ color, setColor }: ChoiceColorProps) => {
    return (
        <div className={styles.container}>
            <CircleColor onClick={() => setColor("silver")} isActive={color === "silver"} color={"silver"} />
            <CircleColor onClick={() => setColor("white")} isActive={color === "white"} color={"white"} />
            <CircleColor onClick={() => setColor("red")} isActive={color === "red"} color={"red"} />
            <CircleColor onClick={() => setColor("orange")} isActive={color === "orange"} color={"orange"} />
            <CircleColor onClick={() => setColor("yellow")} isActive={color === "yellow"} color={"yellow"} />
            <CircleColor onClick={() => setColor("blue")} isActive={color === "blue"} color={"blue"} />
            <CircleColor onClick={() => setColor("black")} isActive={color === "black"} color={"black"} />
            {isNewSite() && (
                <CircleColor
                    onClick={() => setColor("totalWhite")}
                    style={{ marginRight: 0 }}
                    isActive={color === "totalWhite"}
                    color={"totalWhite"}
                />
            )}
        </div>
    );
};

export default ChoiceColor;
